// extracted by mini-css-extract-plugin
export var createdDate = "_im-1";
export var divider = "_im-2";
export var headerDivider = "_im-3";
export var messagesCard = "_im-0";
export var messagesContainer = "_im-6";
export var messagesContainerWrapper = "_im-4";
export var showLeftPanelButton = "_im-8";
export var topButtons = "_im-7";
export var withPadding = "_im-5";